import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-hashtags-to-follow',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hashtags-to-follow.component.html',
  styleUrls: ['./hashtags-to-follow.component.scss']
})
export class HashtagsToFollowComponent implements OnInit, OnChanges {
  @Input() widgetDesc: string;
  @Input() suggestion: any;
  headerTitle: string = 'Hashtags to Follow';
  constructor(private a_route: ActivatedRoute) { }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }

    this.a_route.queryParams.subscribe((res) => {
      if(res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
        this.headerTitle=res.menu;
      }
   })

  }

}
